// extracted by mini-css-extract-plugin
export default {"accordionPanel":"TipsAndSupport_accordionPanel__VRMD2"};